import { render, staticRenderFns } from "./CobrancaNavMenu.vue?vue&type=template&id=0bf914a6"
import script from "./CobrancaNavMenu.vue?vue&type=script&lang=js"
export * from "./CobrancaNavMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports